import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import quotes from '~/assets/images/sprite/quotes.svg'
import { Styles as S } from '~/pages/history/multipleChoice/studyGoal/styles'
import { Styles as BinaryS } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { Styles as SingleS } from '~/pages/onboarding/quizSingleChoice/libs/styles'
import { SvgImage } from '~/shared/components/SvgImage'
import { OptionType } from '~/shared/constants/commonConstants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'Name the author of the quote'

const OPTIONS = [
  { key: 'pythagoras', i18nKey: 'first' },
  { key: 'aristotle', i18nKey: 'second' },
  { key: 'socrates', i18nKey: 'third' },
] as const

const AuthorName = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('history')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <BinaryS.Root>
      <BinaryS.StyledContainer>
        <div>
          <BinaryS.Question>
            <Trans ns="history" i18nKey="onboarding.historyAuthorName.title" />
          </BinaryS.Question>

          <SingleS.StatementContainer>
            <SvgImage svg={quotes} width={16} />
            <SingleS.Statement>
              <Trans
                ns="history"
                i18nKey="onboarding.historyAuthorName.statement"
              />
            </SingleS.Statement>
          </SingleS.StatementContainer>
        </div>

        <div>
          {OPTIONS.map(({ key, i18nKey }) => (
            <S.StyledOption
              key={key}
              type={OptionType.RADIO}
              value={key}
              name="authorName"
              disabled={isAnswersDisabled}
              checked={answer === key}
              onChange={(optionValue) => {
                setAnswer(optionValue)
                setIsAnswersDisabled(true)
                handleChange(optionValue, handleContinue)
              }}
            >
              <S.Value>
                <S.ValueText>
                  {t(`onboarding.historyAuthorName.options.${i18nKey}`)}
                </S.ValueText>
              </S.Value>
            </S.StyledOption>
          ))}
        </div>
      </BinaryS.StyledContainer>
    </BinaryS.Root>
  )
}

export default AuthorName
